import React from 'react';
import { useNavigate } from 'react-router-dom';

const ChangelogDropdownOption = ({ changeLog }) => {
  const navigate = useNavigate();
  return (
    <div
      className="changelog-list-option"
      onClick={() => {
        if (!changeLog?.navigateTo?.length) return;
        navigate(changeLog?.navigateTo);
      }}
      style={{
        cursor: changeLog?.navigateTo?.length && 'pointer',
      }}>
      <div className="new-tag">New</div> <p className="change-log-title">{changeLog?.title}</p>
    </div>
  );
};

export default ChangelogDropdownOption;
